import { ApiResponseType, BaseResponseType } from '@/types/sharedTypes';
import { authApiService } from '@/api/authApiService';

export const unblockInternalOrganizationUserApi = async (
  userId: string
): Promise<ApiResponseType<BaseResponseType>> => {
  const uri = `/organization/internal/users/${userId}/unblock/`;

  return authApiService.POST(uri, {});
};
